<template>
	<multi-select
			id="select-vendors"
			:class="[{ 'multiselect-sm': small }, customClass]"
			:value="value"
			@input="onInput"
			:options="options"
			:multiple="true"
			label="text"
			track-by="value"
			:close-on-select="false"
			:searchable="true"
			:select-label="''"
			:deselect-label="''"
			:selected-label="'✓'"
			:object="false"
			placeholder="Suche"
			style="height: calc(1.5em + 0.5rem + 2px) !important; font-size: 0.7875rem !important;"
	>
		<template #selection="{ values, isOpen }">
			<div
					class="align-items-center"
					style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-top: 0 !important;"
			>
        <span
						v-for="option in values"
						:key="option.value"
						class="p-1 position-relative"
						style="font-size: 0.7875rem; font-weight: normal !important;"
				>
          {{ option.text }}
        </span>

				<input
						v-if="isOpen"
						type="text"
						class="border-0 shadow-none"
						style="min-width: 100px; background: transparent;"
				/>
			</div>
		</template>

		<template #singleLabel>
			<span class="d-flex align-items-center"></span>
		</template>

		<template #placeholder>
			<span style=" font-size: 0.7875rem !important;">{{ placeholder }}</span>
		</template>

		<template #caret="{ toggle }">
			<div class="multiselect__select p-0" @mousedown.prevent.stop="toggle">
				<span class="d-flex align-items-center justify-content-center"></span>
			</div>
		</template>

		<template #option="{ option }">
			{{ option.text }}
		</template>
	</multi-select>
</template>

<script>
export default {
	name: 'VendorMultiSelect',

	props: {
		value: {
			type: Array,
			default: function () {
				return [];
			}
		},
		options: {
			type: Array,
			default: function () {
				return [];
			}
		},
		placeholder: {
			type: String,
			default: 'Händler'
		},
		small: {
			type: Boolean,
			default: true
		},
		customClass: {
			type: String,
			default: 'mb-2',
		},
	},
	methods: {
		onInput(val) {
			this.$emit('input', val);
			this.$emit('update:modelValue', val);
		}
	}
};
</script>
<style>
.multiselect-sm .multiselect,
.multiselect-sm .multiselect__tags {
	min-height: calc(1.5em + 0.5rem + 2px) !important;
	height: calc(1.5em + 0.5rem + 2px) !important;
}

.multiselect-sm .multiselect__tags {
	padding: 0.125rem 2rem 0.125rem 0.5rem !important;
	border-radius: 0.2rem;
	font-size: 0.7875rem !important;
	display: flex;
	align-items: center;
	overflow: hidden;
}

.multiselect-sm .multiselect__input,
.multiselect-sm .multiselect__single,
.multiselect-sm .multiselect__placeholder {
	margin: 0 !important;
	padding: 0 !important;
	line-height: 1.2 !important;
	font-size: 0.7875rem !important;
}

.multiselect-sm .multiselect__placeholder {
	padding-top: 0 !important;
	margin-bottom: 0 !important;
}

.multiselect-sm .multiselect__select {
	height: calc(1.5em + 0.5rem + 2px) !important;
	width: 2rem !important;
	padding: 0 !important;
	top: 0 !important;
	right: 0 !important;
}
</style>